export const languages = [
  {
    code: 'en',
    name: 'English',
    flag: "https://flagcdn.com/w40/gb.png",
    enabled: true
  },
  {
    code: 'vn',
    name: 'Vietnamese',
    flag: "https://flagcdn.com/w40/vn.png",
    enabled: true
  },
  {
    code: 'pl',
    name: 'Polish',
    flag: "https://flagcdn.com/w40/pl.png",
    enabled: true
  },
  {
    code: 'it',
    name: 'Italian',
    flag: "https://flagcdn.com/w40/it.png",
    enabled: true
  }
]

export const allLanguages = [
  { code: 'zh', name: 'Chinese (Simplified)', flag: 'https://flagcdn.com/w40/cn.png', enabled: false },
  { code: 'el', name: 'Greek', flag: 'https://flagcdn.com/w40/gr.png', enabled: false },
  { code: 'lb', name: 'Luxembourgish', flag: 'https://flagcdn.com/w40/lu.png', enabled: false },
  
  { code: 'da', name: 'Danish', flag: 'https://flagcdn.com/w40/dk.png', enabled: false },
  { code: 'is', name: 'Icelandic', flag: 'https://flagcdn.com/w40/is.png', enabled: false },
  { code: 'ms', name: 'Malay', flag: 'https://flagcdn.com/w40/my.png', enabled: false },
  
  { code: 'nl', name: 'Dutch', flag: 'https://flagcdn.com/w40/nl.png', enabled: false },
  { code: 'id', name: 'Indonesian', flag: 'https://flagcdn.com/w40/id.png', enabled: false },
  { code: 'my', name: 'Myanmar (Burmese)', flag: 'https://flagcdn.com/w40/mm.png', enabled: false },
  
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/gb.png', enabled: true },
  { code: 'ga', name: 'Irish', flag: 'https://flagcdn.com/w40/ie.png', enabled: false },
  { code: 'no', name: 'Norwegian', flag: 'https://flagcdn.com/w40/no.png', enabled: false },
  
  { code: 'et', name: 'Estonian', flag: 'https://flagcdn.com/w40/ee.png', enabled: false },
  { code: 'it', name: 'Italian', flag: 'https://flagcdn.com/w40/it.png', enabled: true },
  { code: 'pl', name: 'Polish', flag: 'https://flagcdn.com/w40/pl.png', enabled: true },
  
  { code: 'tl', name: 'Filipino', flag: 'https://flagcdn.com/w40/ph.png', enabled: false },
  { code: 'ja', name: 'Japanese', flag: 'https://flagcdn.com/w40/jp.png', enabled: false },
  { code: 'pt', name: 'Portuguese', flag: 'https://flagcdn.com/w40/pt.png', enabled: false },
  
  { code: 'fi', name: 'Finnish', flag: 'https://flagcdn.com/w40/fi.png', enabled: false },
  { code: 'ko', name: 'Korean', flag: 'https://flagcdn.com/w40/kr.png', enabled: false },
  { code: 'ru', name: 'Russian', flag: 'https://flagcdn.com/w40/ru.png', enabled: false },
  
  { code: 'fr', name: 'French', flag: 'https://flagcdn.com/w40/fr.png', enabled: false },
  { code: 'lv', name: 'Latvian', flag: 'https://flagcdn.com/w40/lv.png', enabled: false },
  { code: 'sk', name: 'Slovak', flag: 'https://flagcdn.com/w40/sk.png', enabled: false },
  
  { code: 'de', name: 'German', flag: 'https://flagcdn.com/w40/de.png', enabled: false },
  { code: 'lt', name: 'Lithuanian', flag: 'https://flagcdn.com/w40/lt.png', enabled: false },
  { code: 'sl', name: 'Slovenian', flag: 'https://flagcdn.com/w40/si.png', enabled: false },
  
  { code: 'vn', name: 'Vietnamese', flag: 'https://flagcdn.com/w40/vn.png', enabled: true },
  { code: 'mk', name: 'Macedonian', flag: 'https://flagcdn.com/w40/mk.png', enabled: false },
  { code: 'es', name: 'Spanish', flag: 'https://flagcdn.com/w40/es.png', enabled: false },
]